import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';
import { faLike } from '../../styles/mixins';
import { dropdownWithTriangle } from '../../styles/dropdownMixins';

const defClr = color => ({
  color,
  '&::before': {
    backgroundColor: color,
  },
});

export const useTopMenuStyles = createStyles(({ token }) => ({
  topMenu: {
    display: 'flex',
    height: 42,

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      height: 42,
    },
  },
  menuItem: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 25px',

    [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
      {
        padding: '0 22px',
      },
    [`@media (max-width: ${token.screenSMMax}px)`]: {
      padding: '0 7px',
    },

    '> .TopMenu-MenuItemInner': {
      color: ThemeColors.COLOR_GREY3,

      position: 'relative',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'none',
      height: 28,
      fontSize: ThemeFont.FONT_SIZE_LG_PLUS,
      fontWeight: 'bold',

      '&::before': {
        content: "''",
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 2,
      },

      [`@media (max-width: ${token.screenMDMax}px)`]: {
        fontWeight: 500,
      },
      [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px)`]:
        {
          fontSize: token.fontSizeLG,
        },
      [`@media (max-width: ${token.screenXSMax}px)`]: {
        fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
      },
    },
    '&.active > .TopMenu-MenuItemInner': defClr(ThemeColors.COLOR_RED),
    '&:hover > .TopMenu-MenuItemInner': defClr(ThemeColors.COLOR_RED6),
    '&:active > .TopMenu-MenuItemInner, &.ant-dropdown-open:not(:hover) > .TopMenu-MenuItemInner':
      defClr(ThemeColors.COLOR_RED7),

    '&.has-arrow': {
      '> .TopMenu-MenuItemInner::after': {
        fontSize: 21,
        ...faLike('\\f0d7'),

        [`@media (min-width: ${token.screenMDMin}px)`]: {
          marginLeft: 8,
        },
        [`@media (max-width: ${token.screenSMMax}px)`]: {
          marginLeft: 4,
        },
      },
    },

    '&.disabled': {
      cursor: 'not-allowed',
      display: 'none',
    },
  },
  submenu: {
    [`@media (min-width: ${token.screenLGMin}px)`]: {
      ...dropdownWithTriangle({
        menuCustom: { width: 175, marginRight: 0 },
        triangleCustom: { right: 18 + ThemeSpaces.SPACE_MD },
        marginTop: -13,
      }),
    },
    [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
      {
        ...dropdownWithTriangle({
          menuCustom: { width: 175, marginRight: -11 },
          triangleCustom: { right: 18 + ThemeSpaces.SPACE_MD },
          marginTop: -13,
        }),
      },
    [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px)`]:
      {
        ...dropdownWithTriangle({
          menuCustom: { width: 175, marginRight: -21 },
          triangleCustom: { right: 18 + ThemeSpaces.SPACE_XS },
          marginTop: -13,
        }),
      },
    [`@media (max-width: ${token.screenXSMax}px)`]: {
      ...dropdownWithTriangle({
        menuCustom: { width: 175, marginRight: -19 },
        triangleCustom: { right: 18 + ThemeSpaces.SPACE_XXS },
        marginTop: -13,
      }),
    },

    '.ant-dropdown-menu-item-disabled, .ant-dropdown-menu-submenu-title-disabled':
      {
        color: ThemeColors.COLOR_GREY3,
      },
  },
}));
